import React, { useState, useEffect } from "react";
import CellFormatingElseStatement from "./CellFormatingElseStatement";
import CellFormatingIfStatement from "./CellFormatingIfStatement";
import { useTranslation } from "react-i18next";

const setDependentValues = ({ attributeType, previousOperator, statement }) => {
    const operator = statement.operator.value;
    const updatedStatement = { ...statement };
    if (operator === "Positive" || operator === "Negative") {
        updatedStatement.condition1 = "";
        updatedStatement.condition2 = "";
        return updatedStatement;
    }
    if (attributeType === "Picklist String" || attributeType === "State Field" || attributeType === "Tags") {
        if (operator === "Equal to" || operator === "Not equal to") {
            if (typeof updatedStatement.condition1 === "object") {
                updatedStatement.condition1 = updatedStatement.condition1[0] || "";
            }
        } else if (operator === "In" || operator === "Not in") {
            if (typeof updatedStatement.condition1 === "string") {
                updatedStatement.condition1 = updatedStatement.condition1 === "" ? [] : [updatedStatement.condition1];
            }
        }
        return updatedStatement;
    }
    if (attributeType === "Number") {
        if (
            operator === "Equal to" ||
            operator === "Not equal to" ||
            operator === "Greater than" ||
            operator === "Less than" ||
            operator === "Greater than or equal to" ||
            operator === "Less than or equal to"
        ) {
            updatedStatement.condition2 = "";
        }
        return updatedStatement;
    }
    if (attributeType === "DateTime") {
        if (
            operator === "Equal to" ||
            operator === "Not equal to" ||
            operator === "Greater than" ||
            operator === "Less than" ||
            operator === "Greater than or equal to" ||
            operator === "Less than or equal to" ||
            operator === "Days selected"
        ) {
            updatedStatement.condition2 = "";
        }
        if (operator === "Days selected" && previousOperator !== "Days selected") {
            updatedStatement.condition1 = [];
        } else if (previousOperator === "Days selected" && operator !== "Days selected") {
            updatedStatement.condition1 = "";
        }
        return updatedStatement;
    }
    return updatedStatement;
}

const intialState = {
    ifStatement: [],
    elseStatement: []
}

export const CellFormating = (props) => {

    const { t } = useTranslation([
        "attribute/cell_formatting",
    ]);

    const { attribute, updateAttribute, } = props;

    const [state, setState] = useState(intialState);

    useEffect(() => {
        const { cellFormatting } = attribute;
        setState({
            ifStatement: cellFormatting?.ifStatement || [],
            elseStatement: cellFormatting?.elseStatement || []
        });
    }, [attribute]);

    const addNewIfStatement = () => {
        const newState = { ...state };
        const updatedIfStatement = [...newState.ifStatement];
        const id = updatedIfStatement.length + 1;
        updatedIfStatement.push({
            id: id,
            operator: {
                text: t("operators.equal_to"),
                value: "Equal to"
            },
            colorOption: {
                text: t("color_options.text_color"),
                value: "Text color"
            },
            color: "rgba(34, 34, 34, 1)",
            condition1: "",
            condition2: ""
        });

        newState.ifStatement = updatedIfStatement;
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    const removeIfStatement = (statementId) => {
        const newState = { ...state };
        const updatedIfStatement = newState.ifStatement.filter((statement) => statement.id !== statementId);
        if (updatedIfStatement.length === 0) {
            newState.elseStatement = [];
        }
        newState.ifStatement = updatedIfStatement;
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    const updateIfStatement = (updatedStatement) => {
        const newState = { ...state };
        const previousStatement = newState.ifStatement.find((statement) => statement.id === updatedStatement.id);
        const updatedDependentValueInStatement = setDependentValues({
            attributeType: attribute.attributeType,
            previousOperator: previousStatement.operator,
            statement: updatedStatement
        });
        const updatedIfStatement = newState.ifStatement.map((statement) => {
            if (statement.id === updatedDependentValueInStatement.id) {
                return updatedDependentValueInStatement;
            }
            return statement;
        });
        newState.ifStatement = updatedIfStatement;
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    const addNewElseStatement = () => {
        const newState = { ...state };
        newState.elseStatement = [
            {
                id: 1,
                colorOption: {
                    text: t("color_options.text_color"),
                    value: "Text color"
                },
                color: "rgba(34, 34, 34, 1)"
            }
        ];
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    const removeElseStatement = (statementId) => {
        const newState = { ...state };
        const updatedElseStatement = newState.elseStatement.filter((statement) => statement.id !== statementId);
        newState.elseStatement = updatedElseStatement;
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    const updateElseStatement = (updatedStatement) => {
        const newState = { ...state };
        const updatedElseStatement = newState.elseStatement.map((statement) => {
            if (statement.id === updatedStatement.id) {
                return updatedStatement;
            }
            return statement;
        });
        newState.elseStatement = updatedElseStatement;
        setState(newState);
        updateAttribute("cellFormatting", newState);
    }

    return (
        <div className="row">
            <div className="col-12">
                {state.ifStatement.length < 5 &&
                    <button
                        onClick={addNewIfStatement}
                        type="button"
                        className="btn hover-bg-7 hover-border-0 focus-border-0 active-border-0 d-inline-block t-primary pointer me-3"
                    >
                        <i className="me-2 fa fa-plus"></i>
                        {state.ifStatement.length === 0 ?
                            t("add_color_formatting")
                            :
                            t("add_if_condition")
                        }
                    </button>
                }
                {state.ifStatement.length > 0 && (state.elseStatement === 0 || state.elseStatement < 2) && (
                    <button
                        onClick={addNewElseStatement}
                        type="button"
                        className="btn hover-bg-7 hover-border-0 focus-border-0 active-border-0 d-inline-block t-primary pointer me-3"
                    >
                        <i className="me-2 fa fa-plus"></i> {t("add_else_condition")}
                    </button>
                )}
                <div className={state.ifStatement.length > 0 ? "mt-4" : ""}>
                    {
                        state.ifStatement.map((statement) => (
                            <CellFormatingIfStatement
                                key={statement.id}
                                attribute={attribute}
                                statement={statement}
                                removeStatement={removeIfStatement}
                                updateStatement={updateIfStatement}
                            />
                        ))
                    }
                </div>
                <div className={state.elseStatement.length > 0 ? "mb-2" : ""}>
                    {
                        state.elseStatement.map((statement) => (
                            <CellFormatingElseStatement
                                key={statement.id}
                                statement={statement}
                                removeStatement={removeElseStatement}
                                updateStatement={updateElseStatement}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    );
};